import React from "react";
import electionMapLogo from "./assets/electionmap-logo.png";

export const BRAND_COLORS = {
  primaryDarkBlue: "#0a2d7c",
  primaryBrightBlue: "#1666d7",
  accentRed: "#e21039",
};

export const BRAND_MAP_COLOR_PRESETS = [
  { name: "Růžová", hex: "#E6007E" },
  {
    name: "Světle modrá",
    hex: BRAND_COLORS.primaryBrightBlue,
    steps: ["#dceafe", "#91bcf5", BRAND_COLORS.primaryBrightBlue, BRAND_COLORS.primaryDarkBlue],
  },
  {
    name: "Červená",
    hex: BRAND_COLORS.accentRed,
    steps: ["#fde1e7", "#f58aa0", BRAND_COLORS.accentRed, "#7f1028"],
  },
  { name: "Zelená", hex: "#009640" },
  { name: "Oranžová", hex: "#f97316", steps: ["#ffedd5", "#fdba74", "#f97316", "#9a3412"] },
  { name: "Vínová", hex: "#8C1D40" },
  { name: "Fialová", hex: "#8b5cf6", steps: ["#ede9fe", "#c4b5fd", "#8b5cf6", "#4c1d95"] },
  { name: "Žlutá", hex: "#FFD200" },
  { name: "Tyrkysová", hex: "#14B8A6" },
  { name: "Modrá ČR", hex: "#0057A3" },
  { name: "Azurová", hex: "#00AEEF" },
  { name: "Tmavě zelená", hex: "#16A34A" },
  { name: "Limetková", hex: "#84CC16" },
  { name: "Karmínová", hex: "#BE185D" },
  { name: "Královská modrá", hex: "#2563EB" },
  { name: "Sytě oranžová", hex: "#EA580C" },
  { name: "Indigo", hex: "#4F46E5" },
  { name: "Fialová tmavá", hex: "#9333EA" },
  { name: "Petrolejová", hex: "#0891B2" },
  { name: "Olivová", hex: "#65A30D" },
  { name: "Hnědá", hex: "#A16207" },
  { name: "Šedá", hex: "#64748B" },
  { name: "Kamenná", hex: "#57534E" },
  { name: "Růžová světlá", hex: "#EC4899" },
];

export function normalizeHexColor(value) {
  const raw = String(value || "").trim();
  if (!/^#?[0-9a-fA-F]{6}$/.test(raw)) return "";
  return `#${raw.replace("#", "").toLowerCase()}`;
}

export const APP_PAGE_BACKGROUND =
  "radial-gradient(circle at 7% 10%, rgba(22, 102, 215, 0.38) 0%, rgba(63, 131, 230, 0.24) 22%, rgba(144, 190, 248, 0.14) 40%, rgba(255, 255, 255, 0) 62%), linear-gradient(135deg, #cfe1fb 0%, #e9f3ff 42%, #f7fbff 70%, #ffffff 100%)";

export const HEADER_SURFACE_BACKGROUND =
  "linear-gradient(135deg, rgba(248, 251, 255, 0.98) 0%, rgba(239, 246, 255, 0.98) 52%, rgba(255, 255, 255, 0.98) 100%)";

export function ElectionMapLogo({ height = 30, style, alt = "ElectionMap" }) {
  return (
    <img
      src={electionMapLogo}
      alt={alt}
      style={{
        display: "block",
        width: "auto",
        height,
        maxWidth: "100%",
        objectFit: "contain",
        ...style,
      }}
    />
  );
}
